﻿import './job-detail-alert';
import config from './config.json';
import {bindJobAlertSubmit} from "./job-alert";
import {trackVacancyDetailAlertSuccess} from "./google-tag-manager";

const loadInitialStatus = async () => {
	// Fetch current status
	const term = document.getElementById("job-alert-term").value;
	const response = await fetch(
		`${config.basepath}/jobalert/isenabled?term=${term}`);
	const jobAlertCheckbox = document.getElementById("job-alert-toggle");

	if (response.ok) {
		const result = await response.text();
		if (result === "true") {
			jobAlertCheckbox.checked = true;
			document.getElementById("toggle-jobalert-feedback-on").classList.remove("d-none");
			document.getElementById("toggle-jobalert-success-on-yaay").classList.add("d-none");
			document.getElementById("job-alert-toggle-into-text").classList.add("d-none");
		}
	}
}

const toggleJobAlert = async () => {
	const jobAlertCheckbox = document.getElementById("job-alert-toggle");
	jobAlertCheckbox.disabled = true;
	const antiForgeryToken = document.querySelector('#job-alert-form [name="__RequestVerificationToken"]').value;
	const term = document.getElementById("job-alert-term").value;
	const vacancyId = document.getElementById("job-alert-vacancy-id").value;
	const vacancyTitle = document.getElementById("job-alert-vacancy-title").value;
	const email = document.getElementById("job-alert-email").value;

	const response = await fetch(`${config.basepath}/jobalert/toggle`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			"RequestVerificationToken": antiForgeryToken
		},
		body: JSON.stringify({
			term: term,
			vacancyId: vacancyId
		})
	});

	if (response.ok) {
		const responseData = await response.json();

		jobAlertCheckbox.checked = responseData.toggleState;

		if (responseData.toggleState) {
			document.getElementById("toggle-jobalert-feedback-off").classList.add("d-none");
			document.getElementById("toggle-jobalert-feedback-on").classList.remove("d-none");
			trackVacancyDetailAlertSuccess(vacancyId, vacancyTitle, term, email, responseData.userPostalCode, responseData.searchRadius);
		} else {
			document.getElementById("toggle-jobalert-feedback-on").classList.add("d-none");
			document.getElementById("toggle-jobalert-feedback-off").classList.remove("d-none");
		}
	}

	jobAlertCheckbox.disabled = false;
}

const initLoggedIn = async () => {
	await loadInitialStatus();

	const jobAlertCheckbox = document.getElementById("job-alert-toggle");
	jobAlertCheckbox.addEventListener("click", toggleJobAlert);
}


const initLoggedOut = () => {
	bindJobAlertSubmit();
}

export const init = async () => {
	const loggedInForm = document.getElementById("job-alert-logged-in");

	if (loggedInForm)
		await initLoggedIn();
	else
		initLoggedOut();
}
